import getApiClient from '@/plugins/api-client'
import Vue from 'vue'

export default {
  loadFaq () {
    const api = getApiClient(this.$store)
    const faqId = this.$route.params.id

    api.get(`faqs/${faqId}`)
      .then(result => {
        this.faq = result.data
      })
      .catch(error => {
        this.error = error.response
      })
  },

  save () {
    this.errors = {}
    const api = getApiClient(this.$store)
    const method = this.faq.id ? 'patch' : 'post'
    const options = {}

    let endpoint = 'faqs'

    if (method === 'patch') {
      options.headers = {
        'Content-Type': 'application/merge-patch+json',
      }
      endpoint = this.faq['@id']
    }

    api[method](endpoint, this.faq, options)
      .then(result => {
        this.user = result.data
        this.$store.commit('app/raiseSuccess', 'Pergunta salva com sucesso')
        this.$router.push({
          name: 'Faqs',
        })
      })
      .catch(error => {
        if (error.response.status === 422) {
          this.parseErrors(error.response.data)
        }
        this.$store.commit('app/raiseError', 'Falha ao salvar pergunta')
      })
  },

  parseErrors (errors) {
    const self = this

    errors.violations.forEach(violation => {
      Vue.set(self.errors, violation.propertyPath, violation.message)
    })
  },
}
